import React, { useEffect, useState, useRef } from 'react';
import { Button, Card, Col, Divider, Form, Input, Row, Tabs } from 'antd';
import Table, { ColumnProps } from 'antd/lib/table';
import { DatePicker, Space } from 'antd';
import { SearchOutlined, UndoOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import FormItem from 'antd/lib/form/FormItem';
import Search from 'antd/lib/input/Search';
import { RequestService } from '../../../../../../shared-services/vms/src/lib/request.service';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { useForm } from 'antd/lib/form/Form';
import moment from 'moment';
import { RequestByName } from 'libs/shared-models/vms/src/lib/request-form/request.name';
import './visitor-report.css';
import { Excel } from 'antd-table-saveas-excel';

/* eslint-disable-next-line */
export interface ReportProps {}

export const Report = (props: ReportProps) => {
  const [page, setPage] = useState(1);
  const { RangePicker } = DatePicker;
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [requestdata, setRequestData] = useState<any[]>([]);
  const [form] = Form.useForm();
  const onSearch = (value: string) => console.log(value);
  const { TabPane } = Tabs;
  const service = new RequestService();
  
  useEffect(() => {
    getAllCheckInReport();
  }, []);

  const getAllCheckInReport = () => {
    service.getAllCheckInReport().then((res) => {
      if (res.status) {
        setRequestData(res.data);
        console.log(res, 'setRequestData');
        AlertMessages.getSuccessMessage(res.internalMessage);
      } else {
        AlertMessages.getErrorMessage(res.internalMessage);
      }
    });
  };

  const getDateReport = (req) => {
    console.log(req, 'req');
    service.getReport(req).then((res) => {
      if (res.status) {
        setRequestData([]);
        setRequestData(res.data);
        AlertMessages.getSuccessMessage(res.internalMessage);
      } else {
        setRequestData([]);
        AlertMessages.getErrorMessage(res.internalMessage);
      }
    });
  };

  const getByName = (name) => {
    const req = new RequestByName(name);
    console.log(req, 'req');
    service.searchByName(req).then((res) => {
      if (res.status) {
        setRequestData(res.data);
        AlertMessages.getSuccessMessage(res.internalMessage);
      } else {
        AlertMessages.getErrorMessage(res.internalMessage);
      }
    });
  };

  const searchData = () => {
    if (form.getFieldValue('visitorName') !== undefined) {
      getByName(form.getFieldValue('visitorName'));
    } else {
      const fromDate = form.getFieldValue('Date')
        ? moment(form.getFieldValue('Date')[0]).format('YYYY-MM-DD')
        : null;
      const toDate = form.getFieldValue('Date')
        ? moment(form.getFieldValue('Date')[1]).format('YYYY-MM-DD')
        : null;
      const selectedDate = { fromDate, toDate };
      getDateReport(selectedDate);
    }
  };
  

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => {
            handleSearch(selectedKeys, confirm, dataIndex);
          }}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        {console.log(selectedKeys)}
        <Button
          type="primary"
          onClick={() => {
            handleSearch(selectedKeys, confirm, dataIndex);
          }}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        type="search"
        style={{ color: filtered ? '#1890ff' : undefined }}
      />
    ),
    onFilter: (value, record) => {
      return record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : false;
    },
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) =>
      text ? (
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
      ) : null,
  });

  const onReset = () => {
    form.resetFields();
  };
  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  }
  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  }

  const columns: ColumnProps<any>[] = [
    {
      title: 'S.No',
      key: 'sno',
      width: '30px',
      responsive: ['sm'],
      render: (text, object, index) => (page - 1) * 10 + (index + 1),
    },
    {
      title: 'Requisition ID',
      dataIndex: 'requestId',
      width: 130,
      align: 'left',
      ...getColumnSearchProps('requestId'),
    },
    {
      title: `Visitor's Name`,
      dataIndex: 'visitorName',
      width: 150,
      align: 'left',
      ...getColumnSearchProps('visitorName'),
    },
    {
      title: 'Check In',
      dataIndex: 'checkIn',
      width: 150,
      align: 'left',
      render: (value, record) => {
        return (
          <span>
            {record.checkIn
              ? moment(record.checkIn).format('YYYY-MM-DD HH:mm:ss')
              : '-'}
          </span>
        );
      },
    },
    {
      title: 'Check Out',
      dataIndex: 'checkOut',
      width: 150,
      align: 'left',
      render: (value, record) => {
        return (
          <span>
            {record.checkOut
              ? moment(record.checkOut).format('YYYY-MM-DD HH:mm:ss')
              : '-'}
          </span>
        );
      },
    },
  ];

  const onChange = (pagination, filters, sorter, extra) => {
    console.log('params', pagination, filters, sorter, extra);
  };
  const onClick = (val) => {
    console.log(val, 'val');
  };

  const resetHandler = () => {
    form.resetFields();
    getAllCheckInReport()
  }

  const exportedData = [];
  const excelData = requestdata
  let i = 1;
  const data = [
    { title: 'S No', dataIndex: 'sNo', render: (text, object, index) => { return i++; } },
    { title: 'Requisition ID', dataIndex: 'requestId' },
    { title: 'Visitor Name', dataIndex: 'visitorName' },
    { title: 'Check In', dataIndex: 'checkIn', render: (text, record) => { return record.checkIn ? moment(record.checkIn).format('YYYY-MM-DD HH:mm:ss'): '-'} },
    { title: 'Check Out', dataIndex: 'checkOut', render: (text, record) => { return record.checkOut ? moment(record.checkOut).format('YYYY-MM-DD HH:mm:ss') : '-'} },
  ];

  const exportExcel = () => {
    const excel = new Excel();
    excel
      .addSheet('attendance-report')
      .addColumns(data)
      .addDataSource(requestdata, { str2num: true })
      .saveAs('VistorsData.xlsx');
  }


  return (
    <Card
      title={<span style={{ color: 'white' }}> Visitor Report</span>}
      extra = {<Button onClick={() => { exportExcel(); }}>Get Excel</Button>}
      style={{ textAlign: 'center' }}
      headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
    >
      <br></br>
      <br></br>
      <Form form={form} layout={'vertical'} style={{ padding: '0px' }}>
        <Row>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 5, offset: 1 }}
            lg={{ span: 5, offset: 1 }}
            xl={{ span: 5, offset: 1 }}
            style={{ margin: '1%' }}
          >
            <Form.Item name="Date">
              <RangePicker />
            </Form.Item>
          </Col>
          <Col style={{ margin: '1%' }}>
            <Form.Item name="visitorName">
              <Input placeholder="Search By Name" />
            </Form.Item>
          </Col>
          <Col style={{ margin: '1%' }}>
            <Button
              type="primary"
              icon={<SearchOutlined />}
              // size="small"
              block
              onClick={() => searchData()}
              
            >
              Get Report
            </Button>
          </Col>
          <Col style={{ margin: '1%' }}>
            <Button
              type="primary" 
              icon={<UndoOutlined />}
              onClick={resetHandler}
              style={{ marginLeft: "5px" }}
            >
              Reset
            </Button>
          </Col>
          {/*<Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
            <Search
      placeholder=" search by Requisition ID"
      allowClear
      enterButton="Search"
      //size="large"
      onSearch={onSearch}
      onChange={onClick}
      />
              </Col>
<Col style={{ margin: '1%' }}>
            <Button
              icon={<UndoOutlined />}
              onClick={() => getAllCheckInReport()}
            >
              Reset
            </Button>
            </Col> */}
          <br></br>
        </Row>
      </Form>
      <Table
        rowKey={(record) => record.id}
        columns={columns}
        dataSource={requestdata}
        rowClassName={(record)=> record.checkOut == null ? 'highlighted-row' : ''}
        scroll={{ x: true }}
        //  pagination={}/>
        pagination={{
          showSizeChanger : true,
          onChange(current) {
            setPage(current);
          },
        }}
        onChange={onChange}
        bordered
      />
    </Card>
  );
};
export default Report;
